import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import {
// LoaderButton,
// ModalWithSidebar,
SimpleModal, Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PostChargeDetails from './PostChargeDetails';
import ConfirmTab from './ConfirmTab';
import ResidentsTab from './ResidentsTab';
export default function PostChargeModal(_ref) {
  let _ref$tenantsList = _ref.tenantsList,
    tenantsList = _ref$tenantsList === void 0 ? undefined : _ref$tenantsList,
    _ref$buildingsList = _ref.buildingsList,
    buildingsList = _ref$buildingsList === void 0 ? undefined : _ref$buildingsList,
    handleRefreshTrigger = _ref.handleRefreshTrigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    'custom-attribute': '245-PostChargeModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin"
  }), t('general.post_charge_or_credit'));
  const tabs = [{
    label: t('post_charge_modal.post_to_residents', {
      count: 0
    }),
    name: 'residents'
  }, {
    label: t('post_charge_modal.post_details'),
    name: 'details'
  }, {
    label: t('general.confirm'),
    name: 'confirm'
  }];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  const _useState3 = useState('details'),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTab = _useState4[0],
    setSelectedTab = _useState4[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };

  // const getModalRightButton = () => {
  //   if (selectedTab === 'residents') {
  //     return (
  //       <Button variant="contained" onClick={() => setSelectedTab('details')}>
  //         {t('general.next')}: {t('post_charge_modal.post_details')}
  //       </Button>
  //     );
  //   }
  //   if (selectedTab === 'details') {
  //     return (
  //       <Button variant="contained" onClick={() => setSelectedTab('confirm')}>
  //         {t('general.next')}: {t('general.confirm')}
  //       </Button>
  //     );
  //   }
  //   return (
  //     <LoaderButton
  //       loadingText="Submitting..."
  //       buttonText="Confirm"
  //       successText="Submitted successfully"
  //       errorText="Submitting failed"
  //       status="success"
  //     />
  //   );
  // };

  const handleClose = () => {
    setModalIsOpen(false);
    handleRefreshTrigger();
  };
  const getTab = () => {
    switch (selectedTab) {
      case 'residents':
        return /*#__PURE__*/React.createElement(ResidentsTab, {
          buildingsList: buildingsList,
          tenantsList: tenantsList
        });
      case 'confirm':
        return /*#__PURE__*/React.createElement(ConfirmTab, {
          buildingsList: buildingsList,
          tenantsList: tenantsList
        });
      case 'details':
        return /*#__PURE__*/React.createElement(PostChargeDetails, {
          batchPostCharge: true,
          handleClose: handleClose
        });
      default:
    }
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setModalIsOpen(false),
    handleOpen: () => setModalIsOpen(true),
    handleTabChange: handleTabChange,
    isOpen: modalIsOpen,
    noFooter: true,
    noPadding: true,
    selectedTab: selectedTab
    // rightButton={getModalRightButton()}
    ,
    tabs: tabs,
    title: t('general.post_charge_or_credit'),
    trigger: trigger
  }, getTab());
}
PostChargeModal.propTypes = {
  trigger: PropTypes.node,
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};